var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.2142 9.69911V5.0475C12.2142 2.26433 9.94994 0 7.16672 0C4.3835 0 2.11922 2.26433 2.11922 5.0475H3.23033C3.23033 2.87694 4.99617 1.11111 7.16672 1.11111C9.33728 1.11111 11.1031 2.87694 11.1031 5.0475V8.58228C10.0175 7.73061 8.65039 7.22222 7.16672 7.22222C3.64389 7.22222 0.777832 10.0883 0.777832 13.6111C0.777832 17.1339 3.64389 20 7.16672 20C10.6896 20 13.5556 17.1339 13.5556 13.6111C13.5556 12.1385 13.0545 10.7808 12.2142 9.69911ZM7.16672 18.8889C4.25655 18.8889 1.88894 16.5213 1.88894 13.6111C1.88894 10.7009 4.25655 8.33333 7.16672 8.33333C10.0769 8.33333 12.4445 10.7009 12.4445 13.6111C12.4445 16.5213 10.0769 18.8889 7.16672 18.8889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.1667 10.9336C6.27554 10.9336 5.55054 11.6586 5.55054 12.5498C5.55054 13.2458 5.99282 13.8405 6.61115 14.0675V15.7315H7.72226V14.0675C8.34054 13.8405 8.78287 13.2458 8.78287 12.5498C8.78287 11.6586 8.05787 10.9336 7.1667 10.9336ZM7.1667 13.0548C6.8882 13.0548 6.66165 12.8283 6.66165 12.5498C6.66165 12.2713 6.8882 12.0447 7.1667 12.0447C7.4452 12.0447 7.67176 12.2713 7.67176 12.5498C7.67176 12.8283 7.4452 13.0548 7.1667 13.0548Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.c38175d37d7767f39b8ff41271018e6d.svg";
export { ForwardRef as ReactComponent };